function accordion(openAll) {
    let question = document.querySelectorAll('.accordion__title');

    question.forEach(function(item, index) {
        let container = item.parentElement;

        if( openAll ) {
            open(container);
        } else {
            if(index == 0) {
                open(container);
            }
        }

        item.addEventListener('click', function() {
            let wrapper = container.parentElement;
            if (container.classList.contains('is-active') ) {
                close(container);
            } else {
                let active = wrapper.querySelector('.is-active');
                open(container);

                if(active) {
                    //turn off closing opened elements

                    // close(active);

                    // setTimeout(function() {
                    //     $([document.documentElement, document.body]).animate({
                    //         scrollTop: $(item).offset().top - 100
                    //     }, 300);
                    // }, 500)
                }
            }
        })
    });
}

function close(item) {
    let answer = item.querySelector('.accordion__answer');
    let answerContentHeight = answer.querySelector('.accordion__answerInner').offsetHeight;
    answer.style.maxHeight = answerContentHeight + 'px';
    setTimeout(function() {
        item.classList.remove('is-active');
        answer.style.maxHeight = 0;
    }, 10);
}
function open(item) {
    let answer = item.querySelector('.accordion__answer');
    let answerContentHeight = answer.querySelector('.accordion__answerInner').offsetHeight;

    answer.style.maxHeight = answerContentHeight + 'px';
    item.classList.add('is-active');
    setTimeout(function() {
        answer.style.removeProperty('max-height');
    }, 700);
}

export { accordion }


//////////////////
// WEBPACK FOOTER
// ./js/modules/accordion.js
// module id = 1
// module chunks = 0